import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  // 公积金查询
  {
    path: '/',
    name: 'home',
    component: HomeView
  },


]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
